.
<template>
  <div class="countdown">
    <div class="time-display">
      <span class="start" v-if="isBegin">距离开始还剩：</span>
      <span class="end" v-else>距离结束还剩：</span>
      <div :class="[isBegin ? 'begin-wrapper' : 'end-wrapper']">
        <template v-if="days">
          <div class="time-unit">{{ days }}</div>
          <div class="time-label">天</div>
        </template>
        <template v-else>
          <div class="time-unit">{{ formatTime(hours) }}</div>
          <div class="time-label">:</div>
          <div class="time-unit">{{ formatTime(minutes) }}</div>
          <div class="time-label">:</div>
          <div class="time-unit">{{ formatTime(seconds) }}</div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Countdown",
  props: {
    targetDate: {
      type: String,
      required: true,
    },
    isBegin: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      timer: null,
    };
  },
  mounted() {
    this.startCountdown();
  },
  watch: {
    targetDate(curVal, oldVal) {
      if (curVal) {
        this.startCountdown();
      }
    },
  },
  methods: {
    startCountdown() {
      const updateCountdown = () => {
        const now = new Date();
        const target = new Date(this.targetDate);
        const diff = target - now;
        if (
          this.days == 0 &&
          this.hours == 0 &&
          this.minutes == 0 &&
          this.seconds == 0
        ) {
          this.$emit("updateActivityList");
        }
        const totalSeconds = Math.floor(diff / 1000);
        this.days = Math.floor(totalSeconds / (3600 * 24));
        this.hours = Math.floor((totalSeconds % (3600 * 24)) / 3600);
        this.minutes = Math.floor((totalSeconds % 3600) / 60);
        this.seconds = totalSeconds % 60;

        if (diff <= 0) {
          clearInterval(this.timer);
          this.resetTime();
          return;
        }
      };

      updateCountdown();
      this.timer = setInterval(updateCountdown, 1000);
    },
    formatTime(time) {
      return time < 10 ? `0${time}` : time;
    },
    resetTime() {
      this.days = 0;
      this.hours = 0;
      this.minutes = 0;
      this.seconds = 0;
    },
  },
};
</script>

<style scoped>
.countdown {
  display: flex;
  font-family: "Arial", sans-serif;
}
.time-unit {
  height: 16px;
  line-height: 16px;
  text-align: center;
  padding: 0 3px;
  box-sizing: border-box;
  font-weight: 400;
  font-size: 12px;
  color: #ffffff;
  border-radius: 2px 2px 2px 2px;
}
.time-display {
  display: flex;
  align-items: center;
}
.begin-wrapper {
  display: flex;
  align-items: center;
}
.begin-wrapper .time-unit {
  background-color: #007eff;
}
.begin-wrapper .time-label {
  color: #007eff;
  margin: 0 2px;
}
.end-wrapper {
  display: flex;
  align-items: center;
}
.end-wrapper .time-unit {
  background-color: #e60012 !important;
}
.end-wrapper .time-label {
  color: #e60012;
  margin: 0 2px;
}
.start {
  color: #007eff;
}
.end {
  color: #e60012;
}
</style>
